import * as React from 'react';
import { useToolPanel } from '../../store/tool-panel.context';
import { Button, SpaceBetween } from '@amzn/awsui-components-react';
import { i18nKeys } from '../../utils/i18n.utils';
import { useTranslation } from 'react-i18next';
import { Link as ReactRouterLink } from 'react-router-dom';
import { RoutePath } from '../../RoutePath';
import BrowseChallenges from '@/src/components/common/Challenges/BrowseChallenges';

const ChallengeList: React.FC = () => {
  const { t } = useTranslation();
  const { toggleChallengeInfo } = useToolPanel();

  return (
    <BrowseChallenges
      currentChallengeDescriptors={[]}
      toggleChallengeInfo={toggleChallengeInfo}
      editMode={false}
      // TODO - enable Refresh button for BrowseChallenges table.
      // The refresh button currently doesn't work as calling the API again wipes out the previous results with
      // any new results that weren't included in the previous result set (usually nothing).
      // showRefreshButton
      actionButtons={
        <>
          <SpaceBetween direction="horizontal" size="xs">
            <ReactRouterLink to={RoutePath.CHALLENGE_SETS}>
              <Button variant="normal">{t(i18nKeys.challenges.challengeSets)}</Button>
            </ReactRouterLink>
            <ReactRouterLink to={RoutePath.NEW_CHALLENGE}>
              <Button variant="primary">{t(i18nKeys.challenges.createChallenge)}</Button>
            </ReactRouterLink>
          </SpaceBetween>
        </>
      }
    />
  );
};

export default ChallengeList;
